<template>
<div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
    <div class="modal-header">
    <h3>Editor</h3>
    <button class="close-btn" @click="closeModal"><span class="material-symbols-outlined">
        fullscreen_exit</span>
    </button>
    </div>
    <div class="modal-body">
        <div class="editor">
          <div class="toolbar">
          <button type="button" @click="toggleBold"><b>B</b></button>
          <button type="button" @click="toggleItalic"><i>I</i></button>
          <button type="button" @click="toggleUnderline"><u>U</u></button>
          <button type="button" @click="toggleStrike"><s>S</s></button>
          <button type="button" @click="markPlaceholder"><span class="material-symbols-outlined toolbarIcon ">bolt</span></button>
          <button type="button" @click="addLink"><span class="material-symbols-outlined toolbarIcon ">link</span></button>
          </div>
          <editor-content :editor="editor" class="editor-content" />
        </div>
    </div>
    </div>
</div>
</template>

<script>
import { EditorContent, useEditor } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import Bold from '@tiptap/extension-bold';
import Italic from '@tiptap/extension-italic';
import Underline from '@tiptap/extension-underline';
import Strike from '@tiptap/extension-strike';
import Link from '@tiptap/extension-link';
import HardBreak from '@tiptap/extension-hard-break';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import { Extension } from '@tiptap/vue-3';
const CustomEnter = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.setHardBreak(),
    }
  },
})


export default {
name: 'TextEditorModal',
components: {
    EditorContent,
},
props: {
    content: {
    type: String,
    default: '',
    },
    isOpen: {
    type: Boolean,
    required: true,
    },
},
data() {
    return {
    editorText: this.content,
    editor: useEditor({
    extensions: [
      CustomEnter,
        Bold, Italic, Underline, Strike,
        Link.extend({
        addAttributes() {
            return {
            ...this.parent?.(),
            target: {
                default: '_blank',
                parseHTML: element => element.getAttribute('target') || '_blank',
            },
            };
        },
        }),
        StarterKit.configure({hardBreak: true}), 
        HardBreak.configure({keepMarks: true, keepAttributes: true}),
        Paragraph, 
        Text.configure({HTMLAttributes: {preserveWhitespace: true}})
        ],
        content: this.editorText,
        onUpdate: ({ editor }) => {
        this.editorText = editor.getHTML();
    },
    }),
    activeSections: ['main']
};
},
methods: {
    closeModal() {
    this.$emit('close');
    },
    toggleBold() {
      this.editor.chain().focus().toggleBold().run();
    },
    toggleItalic() {
      this.editor.chain().focus().toggleItalic().run();
    },
    toggleUnderline() {
      this.editor.chain().focus().toggleUnderline().run();
    },
    toggleStrike() {
      this.editor.chain().focus().toggleStrike().run();
    },
    markPlaceholder() {
      const { state, dispatch } = this.editor.view;
      const { from, to } = this.editor.state.selection;
        if (from === to) {
          // Kein Text ausgewählt, Funktion nicht ausführen
          return;
        }
      const selectedText = state.doc.textBetween(from, to);
      const placeholderText = `[[${selectedText}]]`;
        // Transaktion starten, um den markierten Text zu ersetzen
        dispatch(
          state.tr.insertText(placeholderText, from, to));
        },
        addLink() {
      const currentLink = this.editor.getAttributes('link').href || ''; // Prüft, ob ein Link existiert
      const url = prompt('Enter the URL', currentLink); // Zeigt den aktuellen Link im Prompt
      if (url) {
        this.editor.chain().focus().setLink({ href: url, target: '_blank' }).run();
      }
    },
},
watch: {
    editorText(newText) { 
    this.$emit('updateText', newText); // Sende aktualisierte Daten an die Eltern-Komponente
    },
},
mounted() {
this.editor.commands.setContent(this.editorText);   
// Setze eine Mindesthöhe für den Editor und aktiviere das automatische Zeilenumbruchverhalten
this.editor.setOptions({
editorProps: {
    attributes: {
    style: "min-height: 400px; border: 1px solid; border-radius:0px 0px 4px 4px; padding: 0px 5px; font-size: 14px;",
    },
}});}
};
</script>

<style scoped>
.modal-overlay {
position: fixed;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: rgba(0, 0, 0, 0.5);
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
}

.modal-content {
background-color: white;
width: 80%;
max-width: 800px;
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-header {
display: flex;
justify-content: space-between;
align-items: center;
}

.close-btn {
background-color: transparent;
border: none;
font-size: 20px;
cursor: pointer;
}

.close-btn:hover {
background-color: transparent;
}

.toolbarIcon {
font-size: 16px;
}

.toolbar {
  font-size: 16px;
  display: flex;
  gap: 5px;
  border-radius: 4px 4px 0px 0px;
  border: 1px solid;
  border-bottom: none;
  padding: 5px;
}

button {
  padding: 5px 10px;
  cursor: pointer;
  background-color: transparent;
  border: none;
}

button:hover {
  background-color: #ddd;
}

</style>